import { Trans, useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import Modal from '~/components/modals/Modal/Modal';
import ModalActions from '~/components/modals/Modal/ModalActions';
import ModalContent from '~/components/modals/Modal/ModalContent';
import ModalTitle from '~/components/modals/Modal/ModalTitle';
import Text from '~/components/typographies/Text';
import { snack } from '~/hooks/ToastProvider';
import { useAnalytics } from '~/hooks/useAnalytics';
import IconCheck from '~/icons/icon-check.svg?react';
import { ModalProps } from '~/modals/Modal';
import { AnalyticsEvents } from '~/services/analytics';

const AiChatTrialRequestModal = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('chat', { keyPrefix: 'request_modal' });
  const { track } = useAnalytics();

  const handleConfirm = () => {
    track(AnalyticsEvents.PERLA_REQUEST_COMPLETED);
    snack.success(t('success'));
    closeModal();
  };

  return (
    <Modal
      isOpen
      onOpenChange={(open) => {
        if (!open) closeModal();
      }}
    >
      <ModalTitle>{t('title')}</ModalTitle>
      <ModalContent>
        <Text variant="body2" weight="regular" element="p">
          <Trans t={t} i18nKey="description" components={{ strong: <strong />, br: <br /> }} />
        </Text>
      </ModalContent>
      <ModalActions>
        <Button variant="outlined" onClick={() => closeModal()}>
          {t('cancel')}
        </Button>
        <Button action="confirm" Icon={IconCheck} onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default AiChatTrialRequestModal;
